import { Grid } from "@material-ui/core";
import { useState } from "react";
import styles from "./Timeline.module.css";
import { Dialog, DialogContent } from '@material-ui/core';
import BrButton from '@govbr/react-components/lib/BrButton';

const TimeLine = props => {
  let { itens } = props;
  let mesAno = "";
  let exibirBarraSeparacao = false;

  let programasAuxilioBrasilIndependentes = [
    'Benefício Composição Adolescente',
    'Benefício Composição Jovem',
    'Bolsa de Iniciação Científica Júnior',
    'Auxílio Inclusão Produtiva Urbana',
    'Auxílio Esporte Escolar',
    'Auxílio Inclusão Produtiva Rural',
    'Benefício Extraordinário'];

  let titulosCategoriaBolsaFamilia = ['Bolsa Família'];
  let titulosCategoriasProgramasAuxilio = ['Auxílio Inclusão', 'Benefício de Prestação Continuada'];
  // let titulosCategoriasTarifas = ['Tarifa Social de Energia Elétrica'];

  const [ajudaAcionada, setAjudaAcionada] = useState(false);
  const [mensagemAjuda, setMensagemAjuda] = useState('');

  const deveExibirMesAno = (e) => {
    if (mesAno === "") {
      mesAno = e.mes;
      return
    }
    if (mesAno !== e.mes) {
      mesAno = e.mes;
    }
  }

  const barraInicialFoiExibida = () => {
    exibirBarraSeparacao = true;
  }

  const exibirMensagemAjuda = (mensagem) => {
    setAjudaAcionada(!ajudaAcionada);
    setMensagemAjuda(mensagem);
  }

  const IconeAjuda = ({e}) => {
    return (
      <i className={`fas fa-question-circle ${styles.icon}`}
        title="Clique para obter ajuda." onClick={() => exibirMensagemAjuda(e.descricaoAjuda)}>
      </i>
    )
  }

  const itensMappedToElements = itens.map((e, i) => (
    <div key={i}>
      {titulosCategoriaBolsaFamilia.includes(e.categoriaPrograma) &&
        <>
          <div className={styles.timelineItem} />
          {exibirBarraSeparacao && e.mes !== mesAno && <hr />}
          {barraInicialFoiExibida()}
          {e.mes !== mesAno && <div className={styles.mesAno}>{e.mes}</div>}
          {deveExibirMesAno(e)}
          <div key={i+e.codigo} className={styles.timelineContent}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <div className={styles.blocoTitulo}>
                  <div className={styles.tituloSubtitulo}>
                    <>
                        <div><strong>{e.categoriaPrograma}</strong>
                          <IconeAjuda e={e}/>
                        </div>
                    </>
                    <div><strong>{e.detalhePrograma}</strong>{e.descricaoDetalhePrograma}</div>
                    <div className={styles.desc}>{e.descricaoGeral}</div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </>
      }

      {titulosCategoriasProgramasAuxilio.includes(e.categoriaPrograma) &&
        <>
          <div className={styles.timelineItem} />
          {exibirBarraSeparacao && e.mes !== mesAno && <hr />}
          {barraInicialFoiExibida()}
          {e.mes !== mesAno && <div className={styles.mesAno}>{e.mes}</div>}
          {deveExibirMesAno(e)}
          <div key={i+e.codigo} className={styles.timelineContent}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <div className={styles.blocoTitulo}>
                  <div className={styles.tituloSubtitulo}>
                    {!programasAuxilioBrasilIndependentes.includes(e.programa) &&
                      <>
                        <div><strong>{e.categoriaPrograma}</strong>
                          <IconeAjuda e={e}/>
                        </div>
                      </>
                    }

                    {programasAuxilioBrasilIndependentes.includes(e.programa) &&
                      <>
                        <div><strong>{e.categoriaPrograma} - {e.programa}</strong>
                          <IconeAjuda e={e}/>
                        </div>
                      </>
                    }

                    {e.tipoBeneficio.value === 1 &&
                      <div>
                        <div ><strong>Situação: </strong>{e.situacao}</div>
                      </div>
                    }

                    <div>
                      <div ><strong>{e.nomeBeneficiario ?  "Nome: " : "" }</strong>{e.nomeBeneficiario}</div><div ><strong>Valor: </strong>{e.valor} </div>
                    </div>

                    <div><strong>{e.detalhePrograma}</strong>{e.descricaoDetalhePrograma}</div>
                    <div className={styles.desc}>{e.descricaoGeral}</div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </>
      }

      {/* {titulosCategoriasTarifas.includes(e.categoriaPrograma) &&
        <>
          <div className={styles.timelineItem} />
          {exibirBarraSeparacao && e.mes !== mesAno && <hr />}
          {barraInicialFoiExibida()}
          {e.mes !== mesAno && <div className={styles.mesAno}>{e.mes}</div>}
          {deveExibirMesAno(e)}
          <div key={i+e.codigo} className={styles.timelineContent}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <div className={styles.blocoTitulo}>
                  <div className={styles.tituloSubtitulo}>
                    <>
                      <div><strong>Tarifa Social de Energia Elétrica</strong>
                        <IconeAjuda e={e}/>
                      </div>

                      <div><strong>{e.distribuidora}</strong></div>
                      <div>
                        <div><strong>Unidade Consumidora: </strong>{e.unidadeConsumidora}</div>
                      </div>
                      <div>
                        <div><strong>Desconto: </strong>{e.valor} </div>
                      </div>
                    </>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </>
      } */}
    </div>
  ));

  return (
    <div className={styles.vertical}>
       <div className={styles.container} id="topo">
        <Dialog
          open={ajudaAcionada}
          onClose={() => setAjudaAcionada(!ajudaAcionada)}
        >
          <div className={styles.container}>
            <DialogContent>
              <div className={styles.textoDialogo}>
                {mensagemAjuda}
              </div>
            </DialogContent>
            <div className={styles.modalFooter}>
              <BrButton className={styles.button} onClick={() => setAjudaAcionada(false)}>
                OK
              </BrButton>
            </div>
          </div>
        </Dialog>
      </div>
      {itensMappedToElements}
    </div>
  );
};

export default TimeLine;
